module.exports = __webpack_public_path__ + "static/27import-ae023b503fc698eab308109b377a0c7e.png";